import {
    createContext,
    Dispatch,
    SetStateAction,
    useMemo,
    useState,
} from 'react';

export type BlacklistContextType = {
    wordBlackListed: Map<string, string[]>;
    setWordBlackListed: Dispatch<SetStateAction<Map<string, string[]>>>;
};

export const BlacklistContext = createContext<BlacklistContextType>({
    wordBlackListed: new Map<string, string[]>(),
    setWordBlackListed: () => {},
});

export const BlacklistProvider = ({ children }: any) => {
    const [wordBlackListed, setWordBlackListed] = useState<
        Map<string, string[]>
    >(new Map());
    const blacklist = useMemo(
        () => ({
            wordBlackListed,
            setWordBlackListed,
        }),
        [wordBlackListed, setWordBlackListed]
    );

    return (
        <BlacklistContext.Provider value={blacklist}>
            {children}
        </BlacklistContext.Provider>
    );
};
